module.exports = __webpack_public_path__ + "images/thank-you-bg.jpg";